import { createClient } from "@refinedev/supabase";

const SUPABASE_URL = "https://unhhiiwckvtdsvreesoh.supabase.co";
const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVuaGhpaXdja3Z0ZHN2cmVlc29oIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjgyNzUxNjEsImV4cCI6MTk4Mzg1MTE2MX0.viJldQePydT79_tVjaf7rSQviKVPvXjokSkFmFP4nGE";

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY);
